import {
    Tooltip
} from 'bootstrap';

// Check WebP support
const checkWebp = function (feature) {
    const imgSrcs = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    let img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        if (!result) {
            document.body.classList.add('no-webp');
        }
    };
    img.onerror = function () {
        document.body.classList.add('no-webp');
    };
    img.src = 'data:image/webp;base64,' + imgSrcs[feature];
};

checkWebp('lossy');

// Change navbar color on scroll
const navbarColor = function () {

    const navbar = document.getElementsByClassName('main-navbar')[0];
    if (navbar) {
        if (window.scrollY >= 50) {
            navbar.classList.add('main-navbar-scrolled');
        } else {
            navbar.classList.remove('main-navbar-scrolled');
        }
    }

};

window.addEventListener('scroll', navbarColor);
navbarColor();

// Init tooltips
const initTooltips = function () {
    // console.log('Init tooltips');
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
}
document.addEventListener('init-tooltips', initTooltips);
// initTooltips();
